export const isHtmlString = (value: string) => {
  const doc = new DOMParser().parseFromString(value, 'text/html');
  return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
};
